import { PackageProps } from "modules/membership_plan/commercial_membership_plan/packages/store/actionType";
import { MembershipDurationsProps } from "../../membership_duration/store/actionType";

export enum actionTypes {
  //fetch membership plan
  FETCH_MEMBERSHIP_PLANS_REQUEST = "FETCH_MEMBERSHIP_PLANS_REQUEST",
  FETCH_MEMBERSHIP_PLANS_SUCCESS = "FETCH_MEMBERSHIP_PLANS_SUCCESS",
  FETCH_MEMBERSHIP_PLANS_FAIL = "FETCH_MEMBERSHIP_PLANS_FAIL",
  //fetch membership plan summary
  FETCH_MEMBERSHIP_PLAN_SUMMARY_REQUEST = "FETCH_MEMBERSHIP_PLAN_SUMMARY_REQUEST",
  FETCH_MEMBERSHIP_PLAN_SUMMARY_SUCCESS = "FETCH_MEMBERSHIP_PLAN_SUMMARY_SUCCESS",
  FETCH_MEMBERSHIP_PLAN_SUMMARY_FAIL = "FETCH_MEMBERSHIP_PLAN_SUMMARY_FAIL",
  //create membership plan
  CREATE_MEMBERSHIP_PLAN_REQUEST = "CREATE_MEMBERSHIP_PLAN_REQUEST",
  CREATE_MEMBERSHIP_PLAN_SUCCESS = "CREATE_MEMBERSHIP_PLAN_SUCCESS",
  CREATE_MEMBERSHIP_PLAN_FAIL = "CREATE_MEMBERSHIP_PLAN_FAIL",
  //update membership plan
  UPDATE_MEMBERSHIP_PLAN_REQUEST = "UPDATE_MEMBERSHIP_PLAN_REQUEST",
  UPDATE_MEMBERSHIP_PLAN_SUCCESS = "UPDATE_MEMBERSHIP_PLAN_SUCCESS",
  UPDATE_MEMBERSHIP_PLAN_FAIL = "UPDATE_MEMBERSHIP_PLAN_FAIL",
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface MembershipPlansProps {
  id: string;
  membership_duration_id: string;
  membership_end_date: string;
  membership_join_date: string;
  user_id: string;
  membership_details?:MembershipDurationsProps;
}
export interface MembershipPlansSummaryProps {
  duration_type:string;
  id:string;
  product:string;
}
export interface CreateMembershipPlanInput {
  package_id?: string;
  membership_duration_id: string;
  user_id: string | undefined;
}
export interface CreateMembershipPlanInputError {
  membership_duration_id?: string;
  user_id?: string;
}

//fetch membership plan
export interface FetchMembershipPlanRequestAction {
  type: actionTypes.FETCH_MEMBERSHIP_PLANS_REQUEST;
}

export interface FetchMembershipPlanSuccessAction {
  type: actionTypes.FETCH_MEMBERSHIP_PLANS_SUCCESS;
  payload: MembershipPlansProps[];
}

export interface FetchMembershipPlanFailAction {
  type: actionTypes.FETCH_MEMBERSHIP_PLANS_FAIL;
  payload: string;
}

//fetch membership plan summary
export interface FetchMembershipPlanSummaryRequestAction {
  type: actionTypes.FETCH_MEMBERSHIP_PLAN_SUMMARY_REQUEST;
}

export interface FetchMembershipPlanSummarySuccessAction {
  type: actionTypes.FETCH_MEMBERSHIP_PLAN_SUMMARY_SUCCESS;
  payload: MembershipPlansSummaryProps;
}

export interface FetchMembershipPlanSummaryFailAction {
  type: actionTypes.FETCH_MEMBERSHIP_PLAN_SUMMARY_FAIL;
  payload: string;
}

//create membership plan
export interface CreateMembershipPlanRequestAction {
  type: actionTypes.CREATE_MEMBERSHIP_PLAN_REQUEST;
}

export interface CreateMembershipPlanSuccessAction {
  type: actionTypes.CREATE_MEMBERSHIP_PLAN_SUCCESS;
  payload: MembershipPlansProps;
}

export interface CreateMembershipPlanFailAction {
  type: actionTypes.CREATE_MEMBERSHIP_PLAN_FAIL;
  payload: string;
}
//update membership plan
export interface UpdateMembershipPlanRequestAction {
  type: actionTypes.UPDATE_MEMBERSHIP_PLAN_REQUEST;
}

export interface UpdateMembershipPlanSuccessAction {
  type: actionTypes.UPDATE_MEMBERSHIP_PLAN_SUCCESS;
  payload: MembershipPlansProps;
}

export interface UpdateMembershipPlanFailAction {
  type: actionTypes.UPDATE_MEMBERSHIP_PLAN_FAIL;
  payload: string;
}
export type MembershipPlanActions =
  | FetchMembershipPlanRequestAction
  | FetchMembershipPlanSuccessAction
  | FetchMembershipPlanFailAction
  | CreateMembershipPlanRequestAction
  | CreateMembershipPlanSuccessAction
  | CreateMembershipPlanFailAction
  | UpdateMembershipPlanRequestAction
  | UpdateMembershipPlanSuccessAction
  | UpdateMembershipPlanFailAction;
